export async function generatePin(employeeNumber) {
    // Stała wykorzystywana do zaciemnienia związku między numerem pracownika a PIN-em
    const secretConstant = "Qx8@j2!K#s";
    
    // Łączymy stałą z numerem pracownika
    const inputString = `${secretConstant}${employeeNumber}`;
    
    // Kodujemy napis jako UTF-8
    const encoder = new TextEncoder();
    const data = encoder.encode(inputString);
    
    // Obliczamy SHA-256 przy użyciu Web Crypto API
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    
    // Konwertujemy bufor na tablicę bajtów i następnie na napis w formacie szesnastkowym
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    
    // Wykorzystujemy pierwsze 8 znaków skrótu, konwertujemy na liczbę i ograniczamy do 4 cyfr
    const numberFromHash = parseInt(hashHex.substring(0, 8), 16);
    const pin = numberFromHash % 10000;
    
    // Zwracamy PIN w postaci 4-cyfrowego napisu (dodając ewentualne zera na początku)
    return pin.toString().padStart(4, '0');
} 